import Flickity from "flickity";
require('flickity-fade');

export default function () {
  const clientsCarousels = document.querySelectorAll('.js-clients-carousel');
  const pathways = document.querySelectorAll('.pathways__list');
  const isMobile = window.innerWidth <= 768;

  if (pathways) {
    function initCarousel() {
        const isMobile = window.innerWidth <= 768;
    
        pathways.forEach(function (elem) {
          if (elem) {
            const carouselOptions = {
              pageDots: false,
              autoPlay: isMobile ? false : 4000,
              prevNextButtons: elem.children.length > 1,
              wrapAround: true,
              cellAlign: 'left'
            };
    
            if (elem.flickityInstance) {
              elem.flickityInstance.destroy();
            }
    
            elem.flickityInstance = new Flickity(elem, carouselOptions);
          }
        });
      }
    
      initCarousel();
    
      window.addEventListener('resize', initCarousel);
  }

  if (clientsCarousels) {
    clientsCarousels.forEach(function (elem, index) {
        if (elem) {
          let carouselOptions = {
            prevNextButtons: false,
            autoPlay: isMobile ? false : 4000,
            wrapAround: true,
            pageDots: elem.children.length > 1 
          };
  
  
          new Flickity(elem, carouselOptions);
        }
      });
  }
}
